(function () {

  function initVariantUpdater(scope = document) {

    const variantDataEl = scope.querySelector('[data-variants-json]');
    if (!variantDataEl) return;

    const variantData = JSON.parse(variantDataEl.textContent);
    const radios = scope.querySelectorAll('input[type="radio"][name="Size"]');
    const hiddenInput = scope.querySelector('input[name="id"]');
    const productForm = scope.querySelector('form[action*="/cart/add"]');

    if (!radios.length || !hiddenInput || !productForm) return;

    radios.forEach(radio => {
      radio.addEventListener('change', function () {
        if (!this.checked) return;

        const selected = this.value;
        const variant = variantData.find(v =>
          v.option1 === selected ||
          v.option2 === selected ||
          v.option3 === selected
        );

        if (!variant) return;

        hiddenInput.value = variant.id;
        hiddenInput.setAttribute('value', variant.id);
        productForm.dispatchEvent(new Event('change', { bubbles: true }));

        const regular = scope.querySelector('.price__regular .price-item--regular');
        const sale = scope.querySelector('.price__sale .price-item--sale');
        const compare = scope.querySelector('.price__sale .price-item--regular');
        const priceRegular = scope.querySelector('.price__regular');
        const priceSale = scope.querySelector('.price__sale');

        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          sale && (sale.textContent = formatMoney(variant.price));
          compare && (compare.textContent = formatMoney(variant.compare_at_price));
          priceSale?.classList.remove('hidden');
          priceRegular?.classList.add('hidden');
        } else {
          regular && (regular.textContent = formatMoney(variant.price));
          priceSale?.classList.add('hidden');
          priceRegular?.classList.remove('hidden');
        }
      });
    });
  }

  function formatMoney(cents) {
    return 'Dhs. ' + (cents / 100).toFixed(2) + ' AED';
  }

  /* Initial page load */
  document.addEventListener('DOMContentLoaded', () => {
    initVariantUpdater(document);
  });

  /* Quick Add modal load */
  document.addEventListener('quickadd:loaded', () => {
    const modal = document.querySelector('quick-add-modal');
    if (modal) initVariantUpdater(modal);
  });

})();
